export default function getErrorMessage(hasWarnings: boolean) {

    if (hasWarnings) {
        return "Ficheiro não contém erros. Mas existem avisos, por favor verifique antes de avançar."
    }

    return "Ficheiro não contém erros. Pode prosseguir com a importação."
}
